module.exports = __webpack_public_path__ + "static/camera-00aba964b336528b4fd98d0fab37d73d.jpg";